import { render } from "./TipsBlock.vue?vue&type=template&id=16dda732"
import script from "./TipsBlock.vue?vue&type=script&lang=js"
export * from "./TipsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__